import { Component } from "react";

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error(error);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#151210",
                        color: "#F2EADB",
                        padding: "24px",
                        textAlign: "center",
                        fontFamily: "sans-serif",
                    }}
                >
                    <div>
                        <h1 style={{ fontSize: "22px", fontWeight: 600, letterSpacing: "0.1em" }}>RIVER PUB</h1>
                        <p style={{ marginTop: 10, opacity: 0.8 }}>
                            Qualcosa è andato storto. Ricarica la pagina oppure chiamaci: 0573 750254.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}